<template>
  <div class="main-content-container">
    <b-breadcrumb class="pb-2">
      <b-breadcrumb-item>
        <span
          @click="navigateToCustomers"
          class="text-uppercase font-family-medium"
        >
          Customers
        </span>
      </b-breadcrumb-item>
      <b-breadcrumb-item active>
        <span class="text-uppercase font-family-medium"
          >Build Customer Intake</span
        >
      </b-breadcrumb-item>
    </b-breadcrumb>
    <h1
      class="font-lg primary-dark font-family-medium position-relative content-title"
    >
      Build Customer Intake
    </h1>
    <b-dropdown-divider class="ml-3 " />

    <b-row class="mt-5 position-relative" style="left: 1rem">
      <b-col cols="4" class="left-cards-column">
        <h6 class="font-sm primary-dark font-family-medium">General Info</h6>
        <!-- Skeleton loader left column -->
        <b-card
          v-if="isLoading"
          no-body
          class="general-info-card-left border-primary-lighter px-4 pt-4"
        >
          <div class="d-flex w-100 align-items-center">
            <b-skeleton type="avatar" size="10rem"></b-skeleton>
            <div class="d-flex flex-column ml-4 mt-2">
              <b-skeleton width="11rem" class="mb-3"></b-skeleton>
              <b-skeleton width="14rem" class="mb-3"></b-skeleton>
              <b-skeleton width="14rem" class="mb-3"></b-skeleton>
            </div>
          </div>
          <b-form-group>
            <b-row class="client-intake-row">
              <b-col class="mt-4 ml-3" md="11">
                <b-form-group label="First name">
                  <b-skeleton type="input" height="4rem"></b-skeleton>
                </b-form-group>
              </b-col>
              <b-col class="ml-3" md="11">
                <b-form-group label="Last name">
                  <b-skeleton type="input" height="4rem"></b-skeleton>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form-group>
        </b-card>
        <!-- End skeleton loader -->
        <b-card
          v-else
          no-body
          class="general-info-card-left border-primary-lighter px-4 pt-3"
        >
          <b-row
            class="cy-client-intake-avatar-container d-flex align-items-center ml-2 mt-4"
          >
            <b-avatar
              v-if="userAvatar"
              :src="userAvatar"
              size="9rem"
              class="ml-2"
            ></b-avatar>
            <b-avatar
              class="bg--primary ml-2"
              v-else
              :text="userInitials"
              size="9rem"
            ></b-avatar>
            <div class="d-flex flex-column">
              <label class="font-sm file-select ml-4">
                <p class="cursor-pointer secondary--text font-family-regular">
                  Click to upload/update
                </p>
                <p
                  class="cursor-pointer secondary--text font-family-regular reduce-whitespace"
                >
                  profile picture
                </p>
                <input
                  @click="uploadClear"
                  @change="uploadFile"
                  class="cy-client-intake-attach"
                  data-cy="client-intake-attach-photo"
                  type="file"
                  hidden
                  accept="image/*"
                />
              </label>
              <label class="font-sm file-select ml-4" v-if="photoFileTypeError">
                <h6 class="font-sm font-family-regular position-relative danger">
                  Incorrect file type.
                </h6>
                <h6 class="font-sm font-family-regular position-relative danger">
                  Please upload an image.
                </h6>
              </label>
              <label class="font-sm file-select ml-4" v-if="tokenPhotoError">
                <h6 class="font-sm danger reduce-whitespace">
                  User token expired.
                </h6>
                <h6 class="font-sm danger reduce-whitespace">
                  Please logout and login again.
                </h6>
              </label>
            </div>
          </b-row>
          <b-form-group>
            <b-row class="client-intake-row">
              <b-col class="mt-3 ml-4" md="11">
                <b-form-group label="First name">
                  <b-form-input
                    autocomplete="off"
                    size="lg"
                    type="text"
                    placeholder="N/A"
                    class="cy-client-intake-fname"
                    v-model="firstName"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col class="ml-4 mb-3" md="11">
                <b-form-group label="Last name">
                  <b-form-input
                    autocomplete="off"
                    size="lg"
                    type="text"
                    class="cy-client-intake-lname"
                    placeholder="N/A"
                    v-model="lastName"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form-group>
        </b-card>
      </b-col>
      <!-- End left column -->

      <!-- Right column skeleton loaders -->
      <b-col v-if="isLoading" cols="8" class="right-cards-column">
        <h6 class="font-sm primary-dark font-family-medium">
          General Questions
        </h6>
        <b-card class="general-info-card-left border-primary-lighter px-3 pt-1">
          <b-form-group>
            <b-row class="client-intake-row">
              <b-col
                v-for="(n, $index) in 3"
                :key="$index"
                class="mt-4 ml-3"
                md="12"
              >
                <b-skeleton
                  width="35%"
                  height="1.6rem"
                  class="mb-2"
                ></b-skeleton>
                <b-skeleton height="8rem"></b-skeleton>
              </b-col>
            </b-row>
          </b-form-group>
        </b-card>
        <h6 class="font-sm primary-dark font-family-medium mt-4">
          Tasks and Task related preferences
        </h6>
        <b-card
          class="general-info-card-left border-primary-lighter d-flex flex-column pl-4"
        >
          <b-form-group>
            <b-row class="client-intake-row">
              <div
                class="mt-4 mb-3 ml-3 pb-5 px-5 select-tasks-container border-primary-lighter bg-grey"
              >
                <div class="pt-5 d-flex align-items-center">
                  <b-form-group
                    class="w-100"
                    label="Add new task and related preferences"
                  >
                    <b-skeleton type="input" height="4rem"></b-skeleton>
                  </b-form-group>
                </div>
              </div>
            </b-row>
          </b-form-group>
        </b-card>
      </b-col>
      <!-- End right column skeleton loaders -->

      <!-- Right column start -->
      <b-col v-else cols="8" class="right-cards-column">
        <h6
          v-if="questionsList.length > 0"
          class="font-sm primary-dark font-family-medium"
        >
          General Questions
        </h6>
        <b-card
          v-if="questionsList.length > 0"
          class="general-info-card-left border-primary-lighter pl-3 pr-5"
        >
          <b-form-group class="ml-1">
            <b-row class="client-intake-row">
              <b-col
                v-for="item in questionsList"
                :key="item.id"
                class="mt-2 ml-3 cy-client-intake-qlist"
                md="12"
              >
                <b-form-group :label="item.formQuestion.question.title">
                  <b-form-textarea
                    v-model="item.answer.answer"
                    rows="3"
                    size="lg"
                    id="textarea"
                    :disabled="btnDisabled"
                    class="cy-client-intake-general-ans"
                    placeholder="Write here..."
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form-group>
        </b-card>
        <h6 class="font-sm primary-dark font-family-medium mt-4">
          Tasks and Task related preferences
        </h6>
        <b-card
          class="general-info-card-left border-primary-lighter d-flex flex-column pl-5 pr-3"
        >
          <b-form-group>
            <b-row class="client-intake-row">
              <div
                class="mt-4 mb-3 ml-3 pb-5 px-5 select-tasks-container border-primary-lighter bg-grey"
              >
                <div class="pt-4 d-flex align-items-center">
                  <b-form-group
                    class="w-100"
                    label="Add new task and related preferences"
                  >
                    <multiselect
                      placeholder="Select category"
                      @select="getSelectedCategories"
                      @remove="removeSelectedCategory"
                      v-model="selectedCategories"
                      label="title"
                      track-by="id"
                      selectLabel=""
                      deselectLabel=""
                      :disabled="btnDisabled"
                      selectedLabel=""
                      class="custom-multiselect cy-client-intake-categories categories-multiselect tasks-categories client-intake-multiselect"
                      :options="categoryDropdownOptions"
                      :multiple="true"
                    >
                      <template slot="singleLabel" slot-scope="props">
                        <span class="option__desc">
                          <span class="option__title">
                            {{ props.option.title }}
                          </span>
                        </span>
                      </template>
                    </multiselect>
                  </b-form-group>
                </div>
              </div>
            </b-row>
          </b-form-group>
        </b-card>
        <div>
          <h6
            class="font-sm primary-dark font-family-medium mt-4"
            v-if="categoryBoxes.length > 0"
          >
            Questions
          </h6>
        </div>
        <b-row class="client-intake-row">
          <b-col>
            <div
              class="question-card-wrapper"
              v-for="category in categoryBoxes"
              :key="category.id"
            >
              <b-card>
                <div class="question-editor-wrapper">
                  <div class="heading-wrapper">
                    <div class="title-wrapper">
                      <h3 class="font-lg primary-dark font-family-medium">
                        {{ category.title }}
                      </h3>
                    </div>
                    <div
                      class="close-wrapper"
                      @click="onQuestionBoxClose(category)"
                    >
                      <b-icon icon="x" style="font-size: 5rem" />
                    </div>
                  </div>
                  <b-dropdown-divider />
                  <b-form-group class="add-view-category-form-group">
                    <quill-editor
                      placeholder="Write here"
                      rows="10"
                      v-model="category.text"
                      no-resize
                      class="add-category-desc quill-custom"
                      :options="editorOptions"
                    ></quill-editor>
                  </b-form-group>
                </div>
              </b-card>
            </div>
          </b-col>
        </b-row>
        <b-col v-if="showAlert" md="12" class="position-relative mt-5 px-0">
          <b-alert
            class="alert-btn-top custom-alert"
            :show="showAlert"
            :fade="true"
            >{{ alertMsg }}</b-alert
          >
        </b-col>
        <div class="d-flex mt-5 mb-5 invite-btn-container">
          <b-button
            class="btn-pill save-btn px-5 py-3"
            data-cy="client-intake-save-btn"
            @click="saveAnswers"
            :disabled="btnDisabled"
          >
            <b-spinner
              style="width: 14px; height: 14px"
              v-if="showLoading"
              variant="light"
              label="Spinning"
            ></b-spinner>
            {{ `${!showLoading ? "Save" : ""}` }}
          </b-button>
        </div>
      </b-col>
      <!-- End right column -->
    </b-row>
    <b-modal
      centered
      no-close-on-esc
      hide-header
      hide-footer
      no-close-on-backdrop
      class="cy-client-intake-cropper-modal"
      title="Upload Profile Picture"
      v-model="showCropper"
    >
      <b-container fluid>
        <div>
          <p>Upload Image</p>
        </div>
        <div>
          <img
            id="image"
            :src="fileURL"
            ref="source"
            class="cropper-hidden w-100"
          />
        </div>
        <div class="d-flex justify-content-end">
          <b-button
            v-if="!cropperLoading"
            class="cy-client-intake-cropper-cancel cropper-btn btn-primary px-5 py-3 btn-pill mt-3 mb-3"
            @click.prevent="resetModal"
            >Cancel</b-button
          >
          <b-button
            class="cy-client-intake-cropper-save cropper-btn px-5 py-3 btn-pill mt-3 mb-3"
            data-cy="client-intake-cropper-save"
            @click.prevent="submitImage"
            :disabled="cropperLoading"
          >
            <b-spinner
              v-if="cropperLoading"
              style="width: 14px; height: 14px"
              variant="light"
              label="Spinning"
            ></b-spinner>
            {{ `${!cropperLoading ? "Save" : ""}` }}
          </b-button>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import Multiselect from "vue-multiselect";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import { editorOptions, ACCEPTED_IMAGE_FILE_TYPES } from "@/utils/constants";
import Cropper from "cropperjs";
import {
  getCustomerDetails,
  getSubmissions,
  patchCustomerOtherDetails,
  patchIntakeSubmissions,
  // getForm,
  // getFormDetails,
  postPreferences
} from "@/apis/customers";
import { patchAvatar } from "@/apis/auth";
import { getIntakeCategories } from "@/apis/common";
import { ONBOARDING_INTAKE, QUESTION_TYPE_TEXT } from "@/utils/constants";
export default {
  name: "ClientIntake",
  components: {
    Multiselect,
    quillEditor
  },
  watch: {
    selectedCategories(newCategories, oldCategories) {
      // the question boxes will correspond to the categories selected
      this.categoryBoxes = newCategories.map(newCategory => {
        let oldCategory = oldCategories.find(
          _category => _category.id === newCategory.id
        );
        // if the category is already selected, then re-use the old object, since we don't want to replace
        // anything that the user has typed already.
        // If the category doesnt exist then create a brand new object
        if (oldCategory) {
          return this.categoryBoxes.find(
            _category => _category.id === oldCategory.id
          );
        } else {
          return {
            id: newCategory.id,
            text: newCategory.inlineQuestionnaire,
            title: newCategory.title
          };
        }
      });
    }
  },
  computed: {
    btnDisabled() {
      return this.showLoading || this.saveSuccessful;
    },
    categoryDropdownOptions() {
      if (this.categories.length === 0) {
        return [{ id: "1", title: "Select a Category" }];
      }
      return (
        this.categories
          // filter out categories which don't have questions. This is the requirement.
          .filter(
            category =>
              category.inlineQuestionnaire !== null &&
              category.inlineQuestionnaire !== ""
          )
      );
    },
    ...mapState("authModule", ["role"])
  },
  data() {
    return {
      ACCEPTED_IMAGE_FILE_TYPES,
      intakeFormId: "",
      categoryBoxes: [],
      editorOptions,
      saveSuccessful: false,
      firstName: "",
      tokenPhotoError: false,
      photoFileTypeError: false,
      lastName: "",
      employerName: "",
      userAvatar: "",
      profileBlockID: "",
      userInitials: "",
      fullName: "",
      showTravelForm: false,
      showInboxForm: false,
      selectedTask: null,
      questionsList: [],
      staticAnswer1: "",
      staticAnswer2: "",
      answer: "",
      formId: "",
      questionId: "",
      showAlert: false,
      alerDuration: null,
      variant: "",
      alertMsg: "",
      answersList: [],
      submittedList: [],
      showLoading: false,
      selectedFile: null,
      selectedCategories: [],
      cropper: null,
      fileURL: null,
      files: [],
      canvas: null,
      selectedCategoryQuestionaire: [],
      id: "",
      profileId: "",
      image: null,
      roleName: "",
      debouncedUpdatePreview: _.debounce(this.updatePreview, 257),
      cropperLoading: false,
      showCropper: false,
      categories: [],
      isLoading: true
    };
  },
  created() {
    const customerInfo = this.getCustomerInfo();
    const clientIntake = this.getIntakeInfo();
    const intakeCategories = this.getCategories();
    Promise.allSettled([customerInfo, clientIntake, intakeCategories])
      .then(() => {
        console.log("success");
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    async getCustomerInfo() {
      await getCustomerDetails(this.$route.params.profileId)
        .then(res => {
          let { user, profile, role } = res.data;
          this.profileId = profile.profile;
          this.profileBlockID = profile.id;
          this.roleName = role.name;
          this.firstName = user.firstName;
          this.lastName = user.lastName;
          this.fullName = `${this.firstName} ${this.lastName}`;
          // this.employerName = profile.employer;
          this.userAvatar = user.avatarThumbnail;
          this.userInitials = this.fullName.match(/\b(\w)/g).join("");
        })
        .catch(err => {
          console.log(err);
        });
    },
    async getIntakeInfo() {
      await getSubmissions(this.$route.params.profileId)
        .then(res => {
          this.intakeFormId = res.data.results
            .filter(item => item.form.formType === ONBOARDING_INTAKE)
            .map(el => el.form.id)[0];
          this.questionsList = res.data.results
            .filter(item => item.form.formType === ONBOARDING_INTAKE)
            .map(el => el.submissions)[0]
            .filter(
              item =>
                item.formQuestion.question.questionType === QUESTION_TYPE_TEXT
            )
            .sort((a, b) => a.formQuestion.order - b.formQuestion.order);
        })
        .catch(err => {
          console.log(err);
        });
    },
    async getCategories() {
      await getIntakeCategories()
        .then(res => {
          this.categories = res.data.results;
        })
        .catch(err => console.log(err));
    },
    ...mapActions("authModule", ["actionGetUserDetails"]),

    navigateToCustomers() {
      if (this.role === "admin") {
        this.$router.push({ name: "CustomersListAdmin", query: { tab: 0 } });
      } else if (this.role === "assistant") {
        this.$router.push({ name: "DedicatedCustomers" });
      }
    },

    uploadClear(event) {
      event.target.value = "";
      this.photoFileTypeError = false;
    },

    uploadFile(event) {
      const extensions = this.ACCEPTED_IMAGE_FILE_TYPES
        .split(",")
        .filter(item => item[0] === '.');

      this.selectedFile = event.target.files[0];

      const fileExtension = `.${this.selectedFile.name.split(".").reverse()[0]}`
      const isRestrictedFileType = !extensions.includes(fileExtension)
      if (isRestrictedFileType) {
        this.photoFileTypeError = true;
        event.target.value = "";
        return;
      }

      this.fileURL = URL.createObjectURL(this.selectedFile);
      this.showCropper = true;
      if (this.showCropper) {
        setTimeout(() => {
          this.setupCropperInstance();
        }, 100);
      }
    },

    setupCropperInstance() {
      this.image = this.$refs.source;
      this.cropper = new Cropper(this.image, {
        crop: this.debouncedUpdatePreview,
        autoCropArea: 1,
        aspectRatio: 1,
        viewMode: 0,
        scalable: false,
        zoomable: false
      });
    },
    resetModal() {
      this.fileURL = "";
      this.showCropper = false;
      this.selectedFile = null;
    },
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },
    submitImage() {
      this.tokenPhotoError = false;
      if (this.canvas) {
        this.cropperLoading = true;
        this.canvas.toBlob(blob => {
          if (blob) {
            let myFile = new File([blob], "avatar.png");
            const formData = new FormData();
            formData.append("avatar", myFile);
            patchAvatar(this.profileId, formData, this.roleName)
              .then(res => {
                this.showCropper = false;
                this.userAvatar = res.data.avatarThumbnail;
                this.updatePhoto(), (this.avatar = res.data.avatarThumbnail);
              })
              .catch(err => {
                console.log(err);
                if (err.response.status === 401) {
                  this.tokenPhotoError = true;
                }
                this.showCropper = false;
              })
              .finally(() => {
                this.cropperLoading = false;
              });
          }
        });
      }
    },
    updatePhoto() {
      this.actionGetUserDetails()
        .then(() => {
          console.log("success");
        })
        .catch(err => {
          console.log(err);
        });
    },

    updatePreview() {
      this.canvas = this.cropper.getCroppedCanvas();
    },

    deleteForm(index) {
      this.selectedCategories = this.selectedCategories.filter(
        el => this.selectedCategoryQuestionaire[index].categoryID != el.id
      );
      this.selectedCategoryQuestionaire.splice(index, 1);
    },
    getSelectedCategories(selected) {
      console.log(selected);
    },
    removeSelectedCategory(selected) {
      this.selectedCategoryQuestionaire = this.selectedCategoryQuestionaire.filter(
        el => el.categoryID != selected.id
      );
    },
    onQuestionBoxClose(category) {
      let { id } = category;
      this.selectedCategories = this.selectedCategories.filter(
        _category => _category.id !== id
      );
    },
    saveAnswers() {
      this.categoryBoxes.forEach(categoryBox => {
        const data = {
          profile: this.$route.params.profileId,
          detail: categoryBox.text,
          categories: [categoryBox.id]
        };
        postPreferences(this.$route.params.profileId, data)
          .then(() => {
            console.log("success");
          })
          .catch(err => console.log(err));
      });
      this.showLoading = true;
      let payload;
      for (let i = 0; i < this.questionsList.length; i++) {
        payload = {
          answer: {
            answer: this.questionsList[i].answer.answer
          }
        };
        patchIntakeSubmissions(
          this.intakeFormId,
          this.questionsList[i].id,
          payload
        )
          .then(() => {
            this.showAlert = true;
            this.alertMsg = "Saved details successfully!";
            this.showAlert = false;
            this.saveSuccessful = true;
          })
          .catch(err => {
            console.log(err);
            this.showAlert = true;
            if (err.response.status === 401) {
              this.alertMsg =
                "User token expired. Please logout and login again.";
            } else {
              this.alertMsg = "Some error occurred!";
            }
            this.showLoading = false;
          });
      }
      let data = {
        isProfileIntakeSubmitted: true
      };
      patchCustomerOtherDetails(this.profileId, this.profileBlockID, data).then(
        () => {
          this.$router.push({ name: "TaskDashboard" });
        }
      );
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>;

<style lang="scss" scoped>
@import "~@/scss/variables/colors.scss";

.client-intake-multiselect {
  margin-bottom: -1rem;
}
.left-cards-column {
  flex: 0 0 30%;
  max-width: 30%;
}
.right-cards-column {
  flex: 0 0 70%;
  max-width: 70%;
}
.select-tasks-container {
  width: 95%;
  border-radius: 4px;
  position: relative;
  top: 0.3rem;
}
.save-btn,
.add-btn {
  padding: 0.8rem 2.5rem;
}
.delete-form {
  right: 0;
  top: 50%;
}
.cropper-btn {
  margin-left: 2rem;
}
.question-card-wrapper {
  padding-top: 15px;
  .card {
    padding: 2.5rem;
    .question-editor-wrapper {
      background: $grey;
      border-radius: 4px;
      padding: 3rem;
      border: 1px solid $primary-lighter;
      h3 {
        font-size: 24px !important;
        margin: 0;
      }
      li {
        padding: 15px 0 25px 0;
      }
      fieldset {
        margin: 0;
      }
      .heading-wrapper {
        display: flex;
        .title-wrapper {
          display: flex;
          align-items: center;
        }
        .close-wrapper {
          margin-left: auto;
          svg {
            cursor: pointer;
            font-size: 4rem;
            color: #7f97a2;
          }
        }
      }
    }
  }
}
</style>
